export const params = new Map();
